import PropTypes from 'prop-types';
import React from 'react';

import Dropzone from 'react-dropzone';
import {FormattedMessage} from 'react-intl';
import events from '../../../lib/events.js';

class LayoutImageSelect extends React.PureComponent {
  static displayName = 'LayoutImageSelect';

  static propTypes = {
    edit: PropTypes.bool,
    image: PropTypes.string,
    label: PropTypes.string.isRequired,
    setEdit: PropTypes.func,
  };

  state = {
    imageData: this.props.image ? this.props.image : null,
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.image !== nextProps.image) {
      this.setState({
        imageData: nextProps.image,
      });
    }
  }

  onDrop = (files) => {
    if (files.length !== 1) {
      events.publish('error.user', {message: 'Too many files'});
      return;
    }

    let img = new Image();
    let _URL = window.URL || window.webkitURL;

    img.onload = () => {
      let canvas = document.createElement('canvas');

      canvas.style['background-color'] = '#fff';
      canvas.width = img.width;
      canvas.height = img.height;
      let ctx = canvas.getContext('2d');

      ctx.fillStyle = '#fff';
      ctx.drawImage(img, 0, 0);
      setTimeout(() => { // Function sometimes take a long time to load. Put at end of callstack so that page doesn't lag in the meantime
        this.setState({imageData: canvas.toDataURL()});
      }, 0);
    };
    img.onerror = () => {
      events.publish('error.user', {message: 'Invalid file type'});
    };
    img.src = _URL.createObjectURL(files[0]);
  };

  onOpenClick = () => {
    this.refs.dropzone.open();
  };

  getImage = () => {
    return this.state.imageData;
  };

  deleteImage = () => {
    this.setState({imageData: null});
  };

  render() {
    let inner;

    if (this.props.edit && this.state.imageData) {
      inner = <div>
        <img src={this.state.imageData} style={{opacity: 0.5}} width='100%' />
        <button className='btn icon-button image-delete-btn' onClick={this.deleteImage}><i className='bl bl-trash' /></button>
      </div>;
    }

    if (this.props.edit && !this.state.imageData) {
      inner = <div className='layout-image-upload-dashed'>
        <Dropzone ref='dropzone' type='file' onDrop={this.onDrop} accept='image/*' style={{
          padding: 20,
          border: 0,
          width: '100%',
          height: '100%',
          textAlign: 'center',
        }}>
          <div>
            <FormattedMessage id="file.draw.image.file" /> <a><FormattedMessage id="general.browse" /></a>
            <i className='bl bl-screenshot screenshot-image' />
          </div>
        </Dropzone>
      </div>;
    }

    if (!this.props.edit && !this.state.imageData) {
      inner = <div className='layout-image-upload-dashed'>
        <div className='set-edit'><FormattedMessage id="image.upload.logo.click" /> <a onClick={this.props.setEdit}><FormattedMessage id="general.edit" /></a>.</div>
      </div>;
    }

    if (!this.props.edit && this.state.imageData) {
      inner = <div>
        <img src={this.state.imageData} />
      </div>;
    }

    return <div className='form-group layout-image-upload'>
      <label>{this.props.label}</label>
      {inner}
    </div>;
  }
}

export default LayoutImageSelect;
